import React from 'react';
import PropTypes from 'prop-types';
import { withTranslate } from 'shared/hocs/withTranslate';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import creditCardImage from 'shared/assets/images/articles/leasing/credit-card.png';
import savingMoneyImage from 'shared/assets/images/articles/leasing/saving-money.png';
import atmImage from 'shared/assets/images/articles/leasing/atm.png';

import s from './LeasingHowToPayOff.css';

const items = [
  {
    image: creditCardImage,
    text: 'Картой, онлайн в личном кабинете',
  },
  {
    image: savingMoneyImage,
    text: 'В отделении банка-партнера',
  },
  {
    image: atmImage,
    text: 'Через платежные терминалы',
  },
];
class LeasingHowToPayOff extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  renderItem = (image, text) => {
    const txt = this.props.t(text);
    return (
      <div className={s.item} key={txt}>
        <div className={s.bg} />
        <div className={s.itemTitle}>
          {txt}
        </div>
        <div className={s.image}>
          <img alt={txt} src={image} />
        </div>
      </div>
    );
  };
  render() {
    return (
      <div className={s.items}>
        {items.map(item => this.renderItem(item.image, item.text))}
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(LeasingHowToPayOff));



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingHowToPayOff/LeasingHowToPayOff.js